<div class="slider-inner" *ngIf="banners.length > 0 && !isSkeletonBanner; else skeletonBanner">
  <div class="swiper-container swiper-parent home-banner-slider">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide *ngFor="let item of banners ; let i = index">
        <ng-container *ngIf="item.link && !item.link?.includes('Launch') && !item.link.includes('external'); else Link">
          <a [href]="item.link" (click)="$event.preventDefault()" *ngIf="item.images[0].image_desktop">
            <img class="d-block w-100" [src]="item.images[0].image_desktop" (click)="onRedirect(item.link)" [alt]="item.label + ' Banner'">
          </a>
        </ng-container>
        <ng-template #Link>
          <ng-container *ngIf="item.link && !item.link?.includes('Launch') && item.link.includes('external'); else Launch">
            <a [routerLink]="item.link" *ngIf="item.images[0].image_desktop">
              <img class="d-block w-100" (click)="onRedirect(item.link)" [src]="item.images[0].image_desktop" [alt]="item.label + ' Banner'">
            </a>
          </ng-container>
          <ng-template #Launch>
            <ng-container *ngIf="item.link && item.link?.includes('Launch') && !item.link.includes('external'); else noLink">
              <a [routerLink]="item.link" *ngIf="item.images[0].image_desktop">
                <img class="d-block w-100" [src]="item.images[0].image_desktop" (click)="onLaunchGame(item.link)" [alt]="item.label + ' Banner'">
              </a>
            </ng-container>
          </ng-template>
          <ng-template #noLink>
            <img *ngIf="item.images[0].image_desktop" class="d-block w-100" [src]="item.images[0].image_desktop" [alt]="item.label + ' Banner'">
          </ng-template>
        </ng-template>
        </ng-template>
    </owl-carousel-o>
  </div>
  <div class="slider-overlay"></div>
</div>

<ng-template #skeletonBanner>
  <ng-container *ngIf="isSkeletonBanner">
    <div class="no-freeze-spinner-banner">
      <div id="no-freeze-spinner-banner">
        <div>
          <i class="material-icons">
            <div [innerHTML]="svg.casinoIcon | safeHtml"></div>
          </i>
          <i class="material-icons">
            <div [innerHTML]="svg.slotsIcon | safeHtml"></div>
          </i>
          <i class="material-icons">
            <div [innerHTML]="svg.sportsIcon | safeHtml"></div>
          </i>
          <i class="material-icons">
            <div [innerHTML]="svg.fishingIcon | safeHtml"></div>
          </i>
          <div></div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
